<template>
  <div class="campaigns-table-filters">
    <div class="campaigns-table-filters__type">
      <div class="flex-row gap-sm align-middle">
        <div class="no-shrink">
          {{ $t('ADVERTISEMENT.MANAGE_CAMPAIGNS.FILTER_BY_TYPE') }}
        </div>

        <ElSelect v-model="filters.type">
          <ElOption
            v-for="type in campaignTypesList"
            :key="type.value"
            :value="type.value"
            :label="type.label"
          >
            {{ type.label }}
          </ElOption>
        </ElSelect>
      </div>
    </div>

    <div class="campaigns-table-filters__status">
      <div class="flex-row gap-sm align-middle">
        <div>{{ $t('ADVERTISEMENT.MANAGE_CAMPAIGNS.FILTER_BY_STATUS') }}</div>
        <ElSelect v-model="filters.status">
          <ElOption
            v-for="status in campaignStatusList"
            :key="status.value"
            :value="status.value"
            :label="status.label"
          >
            {{ status.label }}
          </ElOption>
        </ElSelect>
      </div>
    </div>
  </div>
</template>

<script>
import { campaignStatus, campaignTypes } from '../common/constants';
import { translateCampaignStatus } from '../common/utility/translators/translateCampaignStatus';

export default {
  name: 'CampaignsTableFilters',
  data() {
    return {
      filters: {
        status: null,
        type: null,
      },
    };
  },
  computed: {
    campaignStatusList() {
      const statusLists = Object.values(campaignStatus).map(status => ({
        value: status,
        label: translateCampaignStatus(status),
      }));

      return [
        {
          value: null,
          label: this.$t('ALL'),
        },
        ...statusLists,
      ];
    },
    campaignTypesList() {
      const typesList = Object.keys(campaignTypes).map(typeKey => ({
        value: campaignTypes[typeKey],
        label: this.$t(`ADVERTISEMENT.CAMPAIGNS.${typeKey}`),
      }));

      return [
        {
          value: null,
          label: this.$t('ALL'),
        },
        ...typesList,
      ];
    },
  },
  watch: {
    filters: {
      handler() {
        this.$emit('update:filters', this.filters);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.campaigns-table-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
</style>
